import request from '@/api-v2/request';
import type { FavoriteListResponseDTO, FavoriteCreateRequestDTO, FavoriteDTO } from '@/api-v2/web/favorites';

export const getAllFavorites = (signal: AbortSignal): Promise<FavoriteListResponseDTO> =>
  request({
    url: `/favorites`,
    method: 'GET',
    signal,
  }).then((o): FavoriteListResponseDTO => o.data);

export const createFavorite = (data: FavoriteCreateRequestDTO): Promise<FavoriteDTO> =>
  request({
    url: `/favorites`,
    method: 'POST',
    data,
  }).then((o): FavoriteDTO => o.data);

export const deleteFavorite = (favoriteId: string): Promise<FavoriteDTO> =>
  request({
    url: `/favorites/${favoriteId}`,
    method: 'DELETE',
  }).then((o): FavoriteDTO => o.data);
